export const hiddenCategories = [25]